<template>
  <div class="dm-example">
    <dm-button type="primary"
      size="large"
      :disabled='disabled'
      @click="handleClick">{{title}}</dm-button>
  </div>
</template>

<script>
import './index.less'
export default {
  name: 'dm-example',
  props: {
    title: {
      type: [String, Number],
      default: ''
    },
    // 是否禁用按钮
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick() {
      this.$emit('event')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DyExample/index.vue